import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

export default function ListenToEarnDialog(props) {

    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <div>
            {/*<Button variant="outlined" onClick={handleClickOpen}>*/}
            {/*    Open alert dialog*/}
            {/*</Button>*/}
            <img src={props.imgSrc} onClick={handleClickOpen} width={250} height={480}/>
            <Dialog
                open={open}
                onClose={handleClose}
                // aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth={'lg'}
            >
                {/*<DialogTitle id="alert-dialog-title">*/}
                {/*    {props.title}*/}
                {/*</DialogTitle>*/}
                <div className="box">
                    {/*<DialogContent >*/}
                        {/*<DialogContentText id="alert-dialog-description">*/}
                        {/*    {props.context.map(t => <div  key={t}>{t}</div>)}*/}
                        {/*</DialogContentText>*/}
                        <img src={props.exImg}width={'800em'} height={'580em'}/>
                    {/*</DialogContent>*/}

                </div>

                <DialogActions>
                    <Button onClick={handleClose} variant="contained">Got it</Button>
                </DialogActions>
            </Dialog>
        </div>
    )


}